/** What in EVII's text becomes a link. Pure, so it is tested without a sheet to render it in. */

const PRODUCT_URL = /^(?:https:\/\/[a-z0-9.-]+)?(\/product\/[a-z0-9]+(?:-[a-z0-9]+)*)$/;

/** Splits on the pieces that link: the partners page, the shop's category pages and cart, and a product page, either the
 *  full url the catalog tool hands EVII or its bare path. Non-capturing inside, so split returns just those pieces. */
export const ROUTE_SPLIT =
  /((?:https:\/\/)?evinitiative\.com\/partners(?:#start)?|(?:https:\/\/[a-z0-9.-]+)?\/product\/[a-z0-9]+(?:-[a-z0-9]+)*|\/(?:commercial-dc|commercial-ac|home-charging|accessories|cart))/;

/** The shop path of a piece that is a product page, whatever origin it was written with. Null on anything else. */
export const productLinkPath = (part: string): string | null => PRODUCT_URL.exec(part)?.[1] ?? null;
